import React from 'react';
import { useMutation } from '@apollo/client';
import users from '../../../../graph/users';
import { TruncatedText } from '@/se/components/typography';
import Switch from 'react-switch';
import { useContext } from 'react';
import { SessionContext } from '../../../../state/Session';
import UserRoles from '../../../../types/UserRoles';

interface StaffCostAccessButtonProps {
  data: {
    id: number;
    staffCostAccess: boolean;
  };
}

export const StaffCostAccessButton = (props: StaffCostAccessButtonProps) => {
  const [updateStaffCostAccess] = useMutation(users.update);
  const sessionContext = useContext(SessionContext) as any;
  const roles = (sessionContext.session?.user?.metadata ?? []) as string[];
  const isSuperAdmin = roles.indexOf(UserRoles.SuperAdmin) >= 0;

  const toggleStaffCostAccess = async () => {
    if (!isSuperAdmin) return;

    await updateStaffCostAccess({
      variables: {
        id: props.data?.id,
        staffCostAccess: !props.data?.staffCostAccess,
      },
    });
  };

  if (!isSuperAdmin) {
    return <TruncatedText>{props.data?.staffCostAccess ? 'Yes' : 'No'}</TruncatedText>;
  }

  return (
    <TruncatedText>
      <Switch
        checked={props.data?.staffCostAccess || false}
        onChange={toggleStaffCostAccess}
        onColor="#86d3ff"
        onHandleColor="#2693e6"
        handleDiameter={22}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={16}
        width={36}
      />
    </TruncatedText>
  );
};

export default StaffCostAccessButton;
